import { Box, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PropsWithChildren, ReactElement, ReactNode } from 'react';

import { PaloModal } from './palo-modal';
import { tokens } from '@synergy/theme-palo';

export interface PaloConfirmationDialogProps {
    isVisible: boolean;
    title?: ReactNode;
    action?: ReactNode;
    /** Confirm as a primary (success) action instead of a destructive one. */
    isSuccessDialog?: boolean;
    onConfirm: () => void;
    onCancel?: () => void;
    cancelText?: ReactNode;
}

/** PALO confirmation dialog with the same API as the legacy ConfirmationDialog. */
export const PaloConfirmationDialog = ({
    isVisible,
    title,
    action,
    isSuccessDialog,
    onConfirm,
    onCancel,
    cancelText,
    children,
}: PropsWithChildren<PaloConfirmationDialogProps>): ReactElement => {
    const actions: ReactNode[] = [];
    if (onCancel) {
        actions.push(
            <Button key="cancel" variant="text" color="inherit" onClick={onCancel} sx={{ color: tokens.color.ink2 }}>
                {cancelText || <FormattedMessage id="app.common.cancel" />}
            </Button>
        );
    }
    actions.push(
        <Button
            key="confirm"
            variant="contained"
            color={isSuccessDialog ? 'primary' : 'error'}
            onClick={onConfirm}
            autoFocus
        >
            {action || <FormattedMessage id="app.common.yes" />}
        </Button>
    );

    return (
        <PaloModal
            isVisible={isVisible}
            title={title || <FormattedMessage id="app.common.modal.warningHeader" />}
            handleClose={onCancel}
            actionChildren={actions}
            width="xs"
        >
            <Box sx={{ whiteSpace: 'pre-line' }}>{children || <FormattedMessage id="app.common.modal.warning" />}</Box>
        </PaloModal>
    );
};
